











































import Vue from 'vue';
import RelatedParts from '@/components/related-part/RelatedParts.vue';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { PartSearchPagination } from './PartSearchPagination';
import PartSearchCard from './PartSearchCard.vue';
import BaseMixin from '@/mixins/BaseMixin';
import { LoadingState } from '@/entities/LoadingState';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import { PartSearchModuleTypes } from '@/store/modules/part-search';
import { Component, Prop, Mixins, Ref, Watch } from 'vue-property-decorator';
import URI from 'urijs';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';
import { RelatedPartsModuleTypes } from '@/store/modules/related-parts';
import { RelatedPart } from '@/entities/RelatedPart';

@Component({
    components: {
        LoadingIndicator,
        PartSearchCard,
        PartSearchPagination,
        RelatedParts,
    },
})
export default class PartSearch extends Mixins(BaseMixin) {
    @Prop(String)
    private searchTerm!: string;
    @Prop(String)
    private brand!: string;
    @Prop(Number)
    private pageNumber!: number;
    @Prop(String)
    private category!: string;
    @Prop(String)
    private partActionLink!: string;
    @Ref('cards')
    private readonly cards!: PartSearchCard[];

    private relatedPartsComponents: RelatedParts[] = [];

    public get baseSearchLinkWithoutPage(): string {
        return new URI('/PartSearch')
            .addQuery({
                searchTerm: isNullOrWhitespace(this.searchTerm) ? undefined : this.searchTerm,
                brand: isNullOrWhitespace(this.brand) ? undefined : this.brand,
                category: isNullOrWhitespace(this.category) ? undefined : this.category,
            })
            .toString();
    }

    public get isCategorySearch(): boolean {
        return !isNullOrWhitespace(this.category);
    }

    public get partSearchResults(): PartSearchResultDetails[] {
        return this.$store.getters[PartSearchModuleTypes.getters.partSearchResults];
    }

    public get totalNumberOfResults(): number {
        return this.$store.getters[PartSearchModuleTypes.getters.totalNumberOfParts];
    }

    public get numberOfPages(): number {
        return this.$store.getters[PartSearchModuleTypes.getters.numberOfPages];
    }

    public get isLoading(): boolean {
        return this.$store.getters[PartSearchModuleTypes.getters.searchResultsLoadingState] === LoadingState.Loading;
    }

    public search(): void {
        this.$store.dispatch(PartSearchModuleTypes.actions.loadSearchResults, {
            searchTerm: this.searchTerm,
            brand: this.brand,
            category: this.category,
            pageNumber: this.pageNumber || 1,
        });
    }

    protected mounted(): void {
        this.search();
        this.injectRelatedPartsComponent();
        window.addEventListener('resize', this.handleResize);
    }

    protected updated(): void {
        this.deleteRelatedPartsComponent();
        this.injectRelatedPartsComponent();
    }

    protected beforeDestroy(): void {
        window.removeEventListener('resize', this.handleResize);
    }

    private get relatedParts(): RelatedPart[] {
        return this.$store.getters[RelatedPartsModuleTypes.getters.relatedParts];
    }

    private handleResize(): void {
        this.deleteRelatedPartsComponent();
        this.injectRelatedPartsComponent();
    }

    private deleteRelatedPartsComponent(): void {
        this.relatedPartsComponents.map((elem) => {
            elem.$el.remove();
            elem.$destroy();
        });
        this.relatedPartsComponents = [];
    }

    private injectRelatedPartsComponent(): void {
        if (!this.cards) {
            return;
        }

        let partIdsWithRelationInRow: string[] = [];
        this.cards.forEach((card, index) => {
            if (card.hasRelatedParts) {
                // store part id to be passed to component
                partIdsWithRelationInRow.push(card.fullPartId);
            }
            const cardElement = card.$el;
            if (
                !cardElement.nextElementSibling ||
                cardElement.getBoundingClientRect().top < cardElement.nextElementSibling.getBoundingClientRect().top
            ) {
                // next row reached, inject relates parts component if related parts detected
                if (partIdsWithRelationInRow.length > 0) {
                    if (!cardElement.parentNode) {
                        return;
                    }
                    const RelatedPartsComponentClass = Vue.extend(RelatedParts);
                    const relatedPartsInstance = new RelatedPartsComponentClass({
                        propsData: {
                            fullPartIds: partIdsWithRelationInRow,
                            partActionLink: this.partActionLink,
                        },
                    }) as RelatedParts;
                    relatedPartsInstance.$mount();
                    cardElement.parentNode.insertBefore(relatedPartsInstance.$el, cardElement.nextSibling);
                    this.relatedPartsComponents.push(relatedPartsInstance);
                }
                partIdsWithRelationInRow = []; // reset collection at end of row
            }
        });
    }
}
